"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _getAddonValue = _interopRequireDefault(require("../../../utils/getAddonValue"));

require("../styles/_addon-selector.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BURN_IN_CAPTIONS = 'BURN_IN_CAPTIONS';
var SRT_CAPTIONS = 'SRT_CAPTIONS';
var ADDON_NAMES_MAP = {
  CHROMA_KEY: 'Chroma Key',
  DURATIONS: 'Longform',
  RUSH_EDIT: 'Rush Edit',
  SRT_CAPTIONS: 'SRT captions',
  BURN_IN_CAPTIONS: 'Burn-in captions'
};

function Addon(_ref) {
  var addon = _ref.addon,
      selected = _ref.selected,
      onAddonSelect = _ref.onAddonSelect;
  var label = addon.label,
      value = addon.value,
      prefix = addon.prefix,
      icon = addon.icon,
      suffix = addon.suffix;
  return _react.default.createElement("div", {
    key: value,
    className: "addon-selector__addon-item"
  }, _react.default.createElement(_uiKit.Icon, {
    name: prefix || icon,
    color: selected ? 'monkey' : 'michael'
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)('addon-selector__addon-item__details', {
      'addon-selector__addon-item__details--selected': selected
    })
  }, _react.default.createElement("span", null, label), suffix), _react.default.createElement(_uiKit.Button, {
    onClick: onAddonSelect,
    type: !selected ? void 0 : 'INVERTED',
    small: true
  }, !selected ? 'INCLUDE' : 'EXCLUDE'));
}

function AddonSelector(_ref2) {
  var _objectSpread2;

  var addonConstants = _ref2.addonConstants,
      includedAddonTypes = _ref2.includedAddonTypes,
      onAddonSelect = _ref2.onAddonSelect;

  var ADDONS = _objectSpread({}, addonConstants, (_objectSpread2 = {}, _defineProperty(_objectSpread2, BURN_IN_CAPTIONS, addonConstants.CAPTIONS(BURN_IN_CAPTIONS)), _defineProperty(_objectSpread2, SRT_CAPTIONS, addonConstants.CAPTIONS(SRT_CAPTIONS)), _objectSpread2));

  return _react.default.createElement("div", {
    className: "addon-selector"
  }, Object.keys(ADDON_NAMES_MAP).map(function (addonTypeName) {
    return ADDONS[addonTypeName] && _react.default.createElement("div", {
      key: addonTypeName,
      className: "addon-selector__type-container"
    }, _react.default.createElement("p", null, ADDON_NAMES_MAP[addonTypeName]), ADDONS[addonTypeName].map(function (addon) {
      return addon.value && _react.default.createElement(Addon, {
        key: "".concat(addonTypeName, "-").concat(addon.value),
        addon: addon,
        selected: includedAddonTypes.includes((0, _getAddonValue.default)(addonTypeName, addon.value)),
        onAddonSelect: onAddonSelect((0, _getAddonValue.default)(addonTypeName, addon.value))
      });
    }));
  }));
}

var _default = (0, _react.memo)(AddonSelector);

exports.default = _default;